import { render, staticRenderFns } from "./ProductionBudget.vue?vue&type=template&id=9020b0e8"
import script from "./ProductionBudget.vue?vue&type=script&lang=js"
export * from "./ProductionBudget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports